'use strict';
import { action } from 'satcheljs';
import { ActivityType } from 'owa-activity-feed';

export const setActivityFeedEnabledInApp = action(
    'ACTIVITY_FEED_OPTION_ENABLE_TYPE',
    (activityTypeIsEnabled: { [key in ActivityType]?: boolean }) => ({
        activityTypeIsEnabled,
    })
);
